export const scheduleFor = ['All', 'Family', 'Group', 'Couple', 'Individual'];

export const religiousAffiliations = [
  'Christian',
  'Muslim',
  'Hindu',
  'Buddhist',
  'Shinto',
  'Judaist',
  'Jain',
  'Sikh',
  'Secular Atheist Agnostic Non Religious',
];

export const genders = ['Male', 'Female', 'Prefer Not To Say'];

export const therapyType = [
  'Listening',
  'Exploring The Past',
  'Teaching New Skill',
  'Challenging Beliefs',
  'Boundaries And Ethics',
  'Empathy And Compassion',
  'Commercial Sex Workers',
  'LGBTQ',
];

export const expertiseIn = [
  'Trauma',
  'Grief And Loss',
  'Substance Abuse',
  'Relationship Issues',
  'Severe Mental Illness',
  'Depression',
  'Anxiety',
  'Adjustment Issues',
  'Child And Adolescent Development',
  'Economic Stress',
  'Safety',
  'Organizational Stress',
];

export const ageGroup = ['Below Thirty', 'Thirty To Fifty Five', 'Above Fifty Five'];

export const yesNo = ['Yes', 'No'];

export const remoteApi = {
  consentForm: 'https://therappconnect.com/consent',
  termsConditions: 'https://therappconnect.com/terms',
};
